var React = require("react");

var PlayerComponent = require("./PlayerComponent");

var PlaylistStore = require("../../../src/stores/PlaylistStore");
var PlaylistActions = require("../../../src/actions/PlaylistActions");

var EmbedComponent = React.createClass({
  getInitialState: function () {
    return {
      playlist: PlaylistStore.getPlaylist(),
      position: PlaylistStore.getPosition(),
      playlistId: PlaylistStore.getPlaylistId(),
      playing: false,
      sync: false,
    };
  },

  componentWillMount: function () {
    PlaylistStore.addChangeListener(this._onChange);

    var that = this;
    window.addEventListener("message", function (e) {
      if (Object.keys(e.data).indexOf("playing") > -1) {
        that.setVideoPlaying(e.data.playing);
      }
    });
  },

  componentDidMount: function () {
    var plId = this.props.playlistId;
    var version = this.props.version;
    PlaylistActions.load(plId, version);
  },

  _onChange: function () {
    this.setState({
      playlist: PlaylistStore.getPlaylist(),
      position: PlaylistStore.getPosition(),
      playlistId: PlaylistStore.getPlaylistId(),
    });
  },

  playerReady: function () {
    var that = this;
    if (this.state.playlist.length) {
      setTimeout(function () {
        that.setPosition(that.state.position === -1 ? 0 : that.state.position);
        if (that.props.party) {
          PlaylistActions.sync(that.state.playlistId);
          that.setState({ sync: true, playing: true });
        }
      }, 0);
    }
  },

  setPosition: function (p) {
    PlaylistActions.changedPlaylist(
      this.state.playlistId,
      { position: p },
      this.state.sync
    );
  },

  setPlaylistChange: function (obj) {
    var playlist =
      obj.playlist === undefined ? this.state.playlist : obj.playlist;
    var position =
      obj.position === undefined ? this.state.position : obj.position;
    // @todo playlist settings?
    PlaylistActions.changedPlaylist(
      this.state.playlistId,
      {
        playlist: playlist,
        position: position,
      },
      this.state.sync
    );
  },

  setVideoPlaying: function (playing) {
    this.setState({ playing: playing });
  },

  toggleVideoPlaying: function () {
    this.setState({ playing: !this.state.playing });
  },

  playPrevious: function () {
    if (this.state.position > 0) this.setPosition(this.state.position - 1);
    if (!this.state.playing) this.toggleVideoPlaying();
  },

  playNext: function () {
    if (this.state.position < this.state.playlist.length - 1)
      this.setPosition(this.state.position + 1);
    if (!this.state.playing) this.toggleVideoPlaying();
  },

  render: function () {
    var previousClass = this.state.position !== 0 ? "" : "disabled";
    var nextClass =
      this.state.position < this.state.playlist.length - 1 ? "" : "disabled";

    var currentTrack = this.state.playlist[this.state.position]
      ? this.state.playlist[this.state.position].title ||
        this.state.playlist[this.state.position].snippet.title
      : "Press play below or choose a song to start.";

    return (
      <div className="greatdj-embed">
        <div className="header">
          <a
            target="_blank"
            href={"http://great.dj/" + this.props.playlistId}
            title="Open in GreatDJ!"
            style={{ color: "white" }}
          >
            <h1>
              GREAT DJ<em>!</em>
            </h1>
          </a>

          <span
            className={"button " + previousClass}
            onClick={this.playPrevious}
          >
            <i className="fas fa-backward " />
          </span>
          <span
            className={
              "currentTrack " + (!this.state.playing ? "disabled" : "")
            }
          >
            {currentTrack}
          </span>
          <span className={"button " + nextClass} onClick={this.playNext}>
            <i className="fas fa-forward " />
          </span>

          <span className="open-playlist">
            <a
              target="_blank"
              href={"http://great.dj/" + this.props.playlistId}
              title="Open in GreatDJ!"
            >
              <i className="fas fa-external-link-alt"></i>
            </a>
          </span>
        </div>
        <PlayerComponent
          playlist={this.state.playlist}
          position={this.state.position}
          onPlayerReady={this.playerReady}
          setPlaylistChange={this.setPlaylistChange}
          embeded={true}
          playing={this.state.playing}
          setVideoPlaying={this.setVideoPlaying}
        />
      </div>
    );
  },
});

module.exports = EmbedComponent;
